import { render, staticRenderFns } from "./GraphsIconCaption.vue?vue&type=template&id=2f3d63a3"
import script from "./GraphsIconCaption.vue?vue&type=script&lang=js"
export * from "./GraphsIconCaption.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports